const { getOffsetTop } = window.BAO.Utils

class ParallaxImage extends window.BAO.CustomElement() {
  connectedCallback () {
    /* eslint-disable-next-line no-undef */
    if (Shopify.designMode) return

    super.connectedCallback()

    this.isTicking = false
    this.lastKnownY = window.scrollY
    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)

    this.updateEl()

    window.setTimeout(() => {
      this.setAttribute('active', '')
    }, 500)
  }

  setupListeners () {
    super.setupListeners()

    window.addEventListener('scroll', this.onScroll.bind(this), {
      passive: true,
    })
  }

  onScroll () {
    this.lastKnownY = window.scrollY
    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false
    this.moveParallaxItem()
  }

  moveParallaxItem () {
    if (!this.offsetHeight) return

    const amountToMoveY = window.BAO.MediaBreakpoints.isXsViewport ? 60 : 80
    const elementHeight = this.offsetHeight

    const scaledItemHeight = elementHeight + amountToMoveY
    const heightDifference = scaledItemHeight - elementHeight

    const elementStartPoint = getOffsetTop(this) - window.innerHeight
    const elementEndPoint = getOffsetTop(this) + elementHeight

    if (this.lastKnownY <= elementStartPoint) {
      this.style.transform = `translate3d(0px, ${amountToMoveY / -2}, 0px)`

      return
    }

    if (this.lastKnownY > elementEndPoint) {
      this.style.transform = `translate3d(0px, ${amountToMoveY / 2}px, 0px)`

      return
    }

    const totalScrollAmount = elementEndPoint - elementStartPoint

    const scrollYAsAPercentageOfJourney =
      (this.lastKnownY - elementStartPoint) / totalScrollAmount

    const transformAmountY =
      heightDifference * scrollYAsAPercentageOfJourney - heightDifference / 2

    this.style.transform = `translate3d(0px, ${transformAmountY}px, 0px)`
  }
}

if (!customElements.get('parallax-image')) {
  customElements.define('parallax-image', ParallaxImage)
}
